import { queryOne } from 'boot/helpers/queries';
import { pushRecent } from 'src/services/recentEntities.service';

/**
 * После входа на карточку курса/пакета фиксируем её в «последних открытых».
 * Работает как afterEach: навигацию не блокирует, ошибки БД глотаем.
 * Название подтягиваем отдельным лёгким запросом (один row по id).
 */
export async function trackRecentEntities (to) {
    if (!to?.name) { return; }

    try {
        if (to.name === 'courseAdmin' && to.params?.id) {
            const id = to.params.id;
            const packageId = to.params.packageId;
            const row = await queryOne(`select author, title from courses where id = '${id}' limit 1`);
            pushRecent('courses', {
                id,
                packageId: packageId ? String(packageId) : null,
                title: row?.author || row?.title || `Курс #${id}`,
            });

            return;
        }

        if (to.name === 'packageCourses' && to.params?.packageId && String(to.params.packageId) !== '0') {
            const id = to.params.packageId;
            const row = await queryOne(`select title from packages where id = '${id}' limit 1`);
            pushRecent('packages', {
                id,
                title: row?.title || `Пакет #${id}`,
            });
        }
    } catch (e) {
        // Отслеживание — вспомогательная функция, ошибку не эскалируем.
        // eslint-disable-next-line no-console
        console.warn('[trackRecentEntities]', e);
    }
}
